import TripItemRailGroup from './trip-item-rail-group-component';
import TripItemRailGroupService from './trip-item-rail-group-service';

const MODULE_NAME = 'app.trip.item-rail-group';
const module = angular.module(MODULE_NAME, [])
    .directive(TripItemRailGroup.DIRECTIVE_NAME, TripItemRailGroup)
    .service('tripItemRailGroupService', TripItemRailGroupService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-group/trip-item-rail-group/trip-item-rail-group-module.js